import { render, staticRenderFns } from "./AppsCardComponent.vue?vue&type=template&id=cbf70616&scoped=true&"
import script from "./AppsCardComponent.vue?vue&type=script&lang=js&"
export * from "./AppsCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf70616",
  null
  
)

export default component.exports